const PhonePeAppStats = {
    registeredUsers: 350,
    townsCount: (num => num.toLocaleString("en-IN"))(11000),
    storeCount: 25,
};

export default PhonePeAppStats;
